import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";

export default function AdminMenu() {
  return (
    <Box>
      <Header />

      <Container maxWidth="xl">
        <Box
          sx={{
            marginTop: 4,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h5" variant="h6" align="left">
            メニュー
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 1,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h5" variant="h6" align="left">
              教職員名簿管理
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center" }}>
            <div>
              <Stack direction="row" spacing={5} sx={{ mt: 1 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/StaffInformationRegister" sx={{ bgcolor: "#82b1ff" }}>
                    教職員情報登録
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    教職員アカウント作成
                  </Typography>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={5} sx={{ mt: 3 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/StaffInformationManagement" sx={{ bgcolor: "#82b1ff" }}>
                    教職員情報管理
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    教職員アカウント情報の変更・確認
                  </Typography>
                </FormControl>
              </Stack>
            </div>
            <Box sx={{ mt: 3 }} />
          </Box>
        </Box>
        <Box
          sx={{
            margin: 1,
            mt: 3,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h5" variant="h6" align="left">
              マスタ管理
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center" }}>
            <div>
              <Stack direction="row" spacing={5} sx={{ mt: 1 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/EvaluationPeriodChange" sx={{ bgcolor: "#82b1ff" }}>
                    評価期間マスタ変更
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    評価期間の変更
                  </Typography>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={5} sx={{ mt: 3 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/UpdateEvaluationList" sx={{ bgcolor: "#82b1ff" }}>
                    評価リストマスタ更新
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    評価リストを更新
                  </Typography>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={5} sx={{ mt: 3 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/UpdateValuationCategoryMaster" sx={{ bgcolor: "#82b1ff" }}>
                    評価カテゴリマスタ更新
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    評価カテゴリを更新
                  </Typography>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={5} sx={{ mt: 3 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/UpdateValuationItemMaster" sx={{ bgcolor: "#82b1ff" }}>
                    評価項目マスタ更新
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    評価項目およびステカを更新
                  </Typography>
                </FormControl>
              </Stack>
            </div>
            <Box sx={{ mt: 3 }} />
          </Box>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}
